import { useState } from "react";
import { useQuery } from "react-query";
import { Button } from "@progress/kendo-react-buttons";
import { filterIcon } from "@progress/kendo-svg-icons";
import ReportsPdfBuilder from "../Components/ReportsPdfBuilder/ReportsPdfBuilder";
import { StandardReportRequest } from "../Components/ReportsPdfBuilder/ReportsPdfBuilderTypes";
import reportApiService from "../Utilities/ReportApiService";
import machinesApiService from "../../Assets/Utilities/MachinesApiService";
import { MachineReadDto } from "../../../Models/Machine/MachinesReadDto";
import { ReactQueryKeys } from "../../../Constants/ClientRoutingConstants";

export default function ReportsPdfBuilderPage() {
  const [filtersOpen, setFiltersOpen] = useState(true);

  const machinesQuery = useQuery<MachineReadDto[]>(
    ReactQueryKeys.AllMachinesQuery,
    () => machinesApiService.getAllMachines()
  );

  // This report only covers HME and Fixed Plant machinery.
  const REPORT_MACHINERY_TYPES = ["HME", "FixedPlant"];
  const hmeMachines = (machinesQuery.data ?? []).filter((m) =>
    REPORT_MACHINERY_TYPES.includes(m.machineryType)
  );

  const generateReport = (request: StandardReportRequest, signal?: AbortSignal) =>
    reportApiService.generateStandardReport(request, signal);

  return (
    <div className="flex h-[calc(100vh-68px)] flex-col p-5">
      <div className="mb-4 flex items-center gap-3">
        <h2 className="gb-h2 mb-0">ML Endpoint Report</h2>
        <Button
          svgIcon={filterIcon}
          togglable
          selected={filtersOpen}
          onClick={() => setFiltersOpen((open) => !open)}
          title="Toggle filters"
        >
          Filters
        </Button>
      </div>
      <div className="min-h-0 flex-1">
        <ReportsPdfBuilder
          machines={hmeMachines}
          onGenerate={generateReport}
          filtersOpen={filtersOpen}
          onCloseFilters={() => setFiltersOpen(false)}
        />
      </div>
    </div>
  );
}
